import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { MotifCheckbox } from "@ey-xd/motif-react";
import { Controller } from "react-hook-form";
import {
	customComparator,
	formatAmountUnitDecimalPlace,
} from "@/utility/common";

const useDefaultUnitDetails = () => {
	const { defaultUnit } = useSelector((state: any) => state.case);
	const decimalPlace = defaultUnit?.decimalPlace;
	const defaultUnitName = defaultUnit?.name;
	return { decimalPlace, defaultUnitName };
};

const CustomHeader = () => {
	const { defaultUnitName } = useDefaultUnitDetails();
	const unitName = defaultUnitName;
	return `(${unitName})`;
};

const amountCellRenderer = (field: string) => (params: any) => {
	const { decimalPlace,defaultUnitName } = useDefaultUnitDetails();
	const amount = params.data[field];
	const formattedDefaultAmount = formatAmountUnitDecimalPlace(amount, decimalPlace);
    return formattedDefaultAmount !== "-" ? `${formattedDefaultAmount} ${defaultUnitName}`: formattedDefaultAmount;
};

export const useColumnDefs = ({
	control,
	handleCheckboxChange,
}: {
	control: any;
	handleCheckboxChange: (value: string, claimId: string, checked:boolean) => void;
}) => {
	const { t } = useTranslation();
	return [
		{
			field: "claimReferenceId",
			headerName: t(
				"pages.paymentStatus.paymentSetup.claim.tableColumnsDetails.claimId"
			),
			width: 200,
			sortable: true,
			comparator: customComparator,
			unSortIcon: true,
			cellRenderer: function (params: any) {
				return (
					<Controller
						name="claimId"
						control={control}
						rules={{ required: true }}
						render={({ field }) => (
							<MotifCheckbox
								checked={field.value === params.data.claimId}
								onChange={(e:any) =>
									handleCheckboxChange(
										params.data.claimReferenceId,
										params.data.claimId,
										e.target.checked
									)
								}
								value={params.data.claimId}
							>
								{params.data.claimReferenceId}
							</MotifCheckbox>
						)}
					/>
				);
			},
		},
		{
			field: "assigneeName",
			headerName: t(
				"pages.paymentStatus.paymentSetup.claim.tableColumnsDetails.assignee"
			),
			width: 150,
			sortable: true,
			comparator: customComparator,
			unSortIcon: true,
			cellRenderer: function (param: any) {
				return param.data.assigneeName !== "" ? param.data.assigneeName : "-";
			},
		},
		{
			cellRenderer: amountCellRenderer("originalAmount"),
			field: "originalAmount",
			headerName: t(
				"pages.paymentStatus.paymentSetup.claim.tableColumnsDetails.originalAmount",
				{ unitName: CustomHeader() }
			),
			width: 150,
			sortable: true,
			unSortIcon: true,
			cellClass: "align-right",
			headerClass: "stepHeaderClass",
		},
		{
			cellRenderer: amountCellRenderer("resolvedAmount"),
			field: "resolvedAmount",
			headerName: t(
				"pages.paymentStatus.paymentSetup.claim.tableColumnsDetails.resolvedAmount",
				{ unitName: CustomHeader() }
			),
			width: 200,
			sortable: true,
			unSortIcon: true,
			cellClass: "align-right",
			headerClass: "stepHeaderClass",
		},
		{
			field: "claimStageName",
			headerName: t(
				"pages.paymentStatus.paymentSetup.claim.tableColumnsDetails.Stage"
			),
			width: 150,
			sortable: true,
			comparator: customComparator,
			unSortIcon: true,
		},
		{
			field: "actionStatusName",
			headerName: t(
				"pages.paymentStatus.paymentSetup.claim.tableColumnsDetails.status"
			),
			width: 200,
			sortable: true,
			comparator: customComparator,
			unSortIcon: true,
		},
	];
};
